export default {
    bot_description: "Bot təsviri",
    bot_name: "Bot adı",
    clinic_account: "Klinika hesabı",
    clinic_site_link: "Klinikanın veb saytına keçid",
    code_for_bonus_payment: "Bonus ödənişi üçün kod",
    code_was_not_sent: "Kod göndərilmədi - müştəri Telegram botuna qoşulmanı yoxlamalıdır",
    code_was_sent_to_patient_through_bot: "Kod Telegram botu vasitəsilə müştəriyə göndərildi",
    connected_to_telegram_bot: "Telegram botuna qoşuldu",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Bot klinika müştərilərinə bonusları toplamağa və ziyarətləri haqqında aktual məlumat almağa kömək edir",
    telegram_bot_instruction_1: "Telegram messencerini açın, hesabınıza daxil olun və ya yenisini yaradın. Axtarış sahəsinə <code>{'@'}BotFather</code> daxil edin və botu seçin",
    telegram_bot_instruction_2: "<code>/newbot</code> əmrini seçin və ya yazın və göndərin",
    telegram_bot_instruction_3: "Bota bir ad verin - müştərilər botla ünsiyyət qurarkən bu adı görəcəklər. Və botun ləqəbi - onun vasitəsilə Telegram-da botu tapmaq mümkün olacaq. Ləqəb unikal olmalıdır, verilənlər bazasında mövcud olanları təkrarlamamalı və bot sözü ilə bitməlidir",
    telegram_bot_instruction_4: "Yaradılmış botdan token dəyərini kopyalayın, aşağıdakı sahəyə yapışdırın və yadda saxlayın",
    use_bonuses_by_confirming_through_telegram_bot: "Telegram bot vasitəsilə təsdiqləməklə bonuslardan istifadə edin",
    wrong_code: "Kod yanlışdır"
}
